import { getAskComposerSurfaceConfig } from '#pplx/frontend/apps/ask/ask-composer/internal/surfaceConfig.js';
import { useSelectedSearchMode } from '#pplx/frontend/apps/ask/hooks/selected-search-mode-hooks/useSelectedSearchMode.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback } from 'react';
const searchModeSelectedEvent = EVENT_PAYLOAD;
export function useAskComposerSearchModeSelected({ surface, }) {
    const selectedSearchMode = useSelectedSearchMode();
    const { track } = useInstrumentation();
    const { searchModeSelectedEventName } = getAskComposerSurfaceConfig(surface);
    return useCallback((searchMode) => {
        if (selectedSearchMode === searchMode)
            return;
        switch (surface) {
            case 'home':
                if (import.meta.env.VITE_IS_SIDECAR_BUILD)
                    return;
                break;
            case 'sessions':
                break;
            default:
                assertUnreachableValue(surface);
        }
        track(searchModeSelectedEvent({
            name: searchModeSelectedEventName,
            data: { previousMode: selectedSearchMode, selectedMode: searchMode },
        }));
    }, [searchModeSelectedEventName, selectedSearchMode, surface, track]);
}
//# sourceMappingURL=useAskComposerSearchModeSelected.js.map